/* ============================================================
   Homepage Events — pure date/grid helpers (unit-tested) +
   HomepageEvents widget (month grid + day-paged carousel,
   sourced from the same public BinderPOS feed CalendarV2 uses).
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) {
    module.exports = api; // Node (unit tests)
  } else {
    root.HomepageEvents = api; // Browser
  }
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  // ---- Pure helpers ----

  function formatISODate(date) {
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return year + "-" + month + "-" + day;
  }

  function getMonthFetchRange(year, month) {
    var firstOfMonth = new Date(year, month, 1);
    var lastOfMonth = new Date(year, month + 1, 0);
    var startDate = new Date(firstOfMonth);
    startDate.setDate(startDate.getDate() - firstOfMonth.getDay());
    var endDate = new Date(lastOfMonth);
    endDate.setDate(endDate.getDate() + (6 - lastOfMonth.getDay()));
    return { startDate: formatISODate(startDate), endDate: formatISODate(endDate) };
  }

  function bucketEventsByDate(events) {
    var byDate = {};
    events.forEach(function (event) {
      var dateKey = event.date ? event.date.split("T")[0] : null;
      if (!dateKey) return;
      if (!byDate[dateKey]) byDate[dateKey] = [];
      byDate[dateKey].push(event);
    });
    return byDate;
  }

  function buildMonthGrid(year, month, byDate, todayISO) {
    var range = getMonthFetchRange(year, month);
    var start = new Date(range.startDate + "T00:00:00");
    var end = new Date(range.endDate + "T00:00:00");
    var cells = [];
    var cursor = new Date(start);
    while (cursor <= end) {
      var iso = formatISODate(cursor);
      var dayEvents = byDate[iso] || [];
      cells.push({
        date: iso,
        inMonth: cursor.getMonth() === month,
        isToday: iso === todayISO,
        hasEvents: dayEvents.length > 0,
        eventCount: dayEvents.length,
        previewBanners: dayEvents.map(function (event) { return event.calendarIcon || event.banner || null; })
      });
      cursor.setDate(cursor.getDate() + 1);
    }
    return cells;
  }

  function formatDayLabel(iso, todayISO) {
    var date = new Date(iso + "T00:00:00");
    var today = new Date(todayISO + "T00:00:00");
    var diffDays = Math.round((date - today) / 86400000);
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Tomorrow";
    var dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return dayNames[date.getDay()] + ", " + monthNames[date.getMonth()] + " " + date.getDate();
  }

  function formatEventTime(time24) {
    if (!time24) return "";
    var parts = time24.split(":");
    var hour = parseInt(parts[0], 10);
    var minute = parts[1] || "00";
    var ampm = hour >= 12 ? "PM" : "AM";
    var hour12 = hour % 12 || 12;
    return hour12 + ":" + minute + " " + ampm;
  }

  function buildEventUrl(event) {
    if (event.handle) {
      return "/pages/events?ticket=" + event.handle;
    }
    return "/pages/events?event=" + escape(event.title).toLowerCase() + "-" + event.id;
  }

  function parseISODate(iso) {
    var parts = iso.split("-");
    return { year: parseInt(parts[0], 10), month: parseInt(parts[1], 10) - 1 };
  }

  function planCarouselJump(currentIndex, targetIndex) {
    if (currentIndex < 0 || targetIndex < 0 || currentIndex === targetIndex) {
      return { preJumpIndex: null, animateMs: 0 };
    }
    var distance = targetIndex - currentIndex;
    if (Math.abs(distance) === 1) {
      return { preJumpIndex: null, animateMs: 300 };
    }
    return { preJumpIndex: targetIndex - Math.sign(distance), animateMs: 300 };
  }

  function planEntryTurn(direction, targetIndex, slideCount) {
    if (!direction || targetIndex < 0) return null;
    var preJumpIndex = targetIndex - direction;
    if (preJumpIndex < 0 || preJumpIndex > slideCount - 1) return null;
    return preJumpIndex;
  }

  function formatWeekdayLabel(iso) {
    var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return "Every " + dayNames[new Date(iso + "T00:00:00").getDay()];
  }

  // ---- HomepageEvents widget (DOM-bound; verified manually in-browser) ----

  function HomepageEvents(container) {
    var self = this;
    this.container = container;
    this.gridEl = container.querySelector(".homepage-events__grid");
    this.carouselEl = container.querySelector(".homepage-events__carousel-track");
    jQuery(this.carouselEl).on("translated.owl.carousel", function (event) {
      // event.page.index is always -1 with dots:false (Owl never builds its
      // pages array); event.item.index is the reliable absolute slide index.
      self.onCarouselTranslated(event.item.index);
    });
    this.monthLabelEl = container.querySelector(".homepage-events__month-label");
    this.weeklyLabelEl = container.querySelector(".homepage-events__weekly-label");
    this._overflowResizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(self._overflowResizeTimer);
      self._overflowResizeTimer = setTimeout(function () {
        self.updateOverflowChips();
      }, 150);
    });
    this.eventsByDate = {};
    this.fetchedRanges = [];
    this.productCache = {};
    this.gridCells = [];
    this.owl = null;
    this._suppressIndex = null;

    var today = new Date();
    this.todayISO = formatISODate(today);
    this.selectedDate = this.todayISO;
    this.currentYear = today.getFullYear();
    this.currentMonth = today.getMonth();

    container.querySelector(".homepage-events__month-prev").addEventListener("click", function () {
      self.goToMonth(-1);
    });
    container.querySelector(".homepage-events__month-next").addEventListener("click", function () {
      self.goToMonth(1);
    });

    this.loadMonth(this.currentYear, this.currentMonth);
  }

  HomepageEvents.prototype.isRangeFetched = function (range) {
    return this.fetchedRanges.some(function (fetched) {
      return fetched.startDate <= range.startDate && fetched.endDate >= range.endDate;
    });
  };

  HomepageEvents.prototype.loadMonth = function (year, month, entryDirection) {
    var self = this;
    var range = getMonthFetchRange(year, month);

    if (this.isRangeFetched(range)) {
      this.currentYear = year;
      this.currentMonth = month;
      this.renderGrid();
      this.renderCarousel(entryDirection);
      return;
    }

    window.GDEventsFeed.getEvents(window.theme.eventsFeed, range.startDate, range.endDate)
      .then(function (events) {
        self.eventsByDate = Object.assign({}, self.eventsByDate, bucketEventsByDate(events));
        self.fetchedRanges.push(range);
        self.currentYear = year;
        self.currentMonth = month;
        self.renderGrid();
        self.renderCarousel(entryDirection);
      })
      .catch(function () {
        self.currentYear = year;
        self.currentMonth = month;
        self.renderGrid();
        self.renderError();
      });
  };

  HomepageEvents.prototype.goToMonth = function (delta) {
    var month = this.currentMonth + delta;
    var year = this.currentYear;
    if (month < 0) {
      month = 11;
      year -= 1;
    }
    if (month > 11) {
      month = 0;
      year += 1;
    }
    this.selectedDate = formatISODate(new Date(year, month, 1));
    this.loadMonth(year, month, delta);
  };

  HomepageEvents.prototype.renderGrid = function () {
    var self = this;
    var cells = buildMonthGrid(this.currentYear, this.currentMonth, this.eventsByDate, this.todayISO);
    var monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.monthLabelEl.textContent = monthNames[this.currentMonth] + " " + this.currentYear;
    this.gridCells = cells;

    this.gridEl.innerHTML = cells.map(function (cell) {
      var classes = ["homepage-events__day"];
      if (!cell.inMonth) classes.push("homepage-events__day--outside");
      if (cell.isToday) classes.push("homepage-events__day--today");
      if (cell.date === self.selectedDate) classes.push("homepage-events__day--selected");
      if (cell.hasEvents) classes.push("homepage-events__day--has-events");
      var dayNumber = parseInt(cell.date.split("-")[2], 10);
      var eventLabel = cell.hasEvents
        ? ", " + cell.eventCount + " event" + (cell.eventCount > 1 ? "s" : "")
        : ", no events";
      var thumbs = "";
      if (cell.previewBanners.length) {
        thumbs = '<span class="homepage-events__day-thumbs" aria-hidden="true">' +
          cell.previewBanners.map(function (banner) {
            return banner
              ? '<img class="homepage-events__day-thumb" loading="lazy" src="' + banner + '" alt="">'
              : '<span class="homepage-events__day-thumb homepage-events__day-thumb--placeholder">' +
                '<svg viewBox="0 0 448 512" width="12" height="12"><path fill="currentColor" d="M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"/></svg>' +
                "</span>";
          }).join("") +
          (cell.eventCount > 1 ? '<span class="homepage-events__day-more" aria-hidden="true"></span>' : "") +
          "</span>";
      }
      return '<button type="button" class="' + classes.join(" ") + '" data-date="' + cell.date + '" aria-label="' + cell.date + eventLabel + '">' +
        '<span class="homepage-events__day-number">' + dayNumber + "</span>" +
        thumbs +
        "</button>";
    }).join("");

    this.gridEl.querySelectorAll(".homepage-events__day").forEach(function (button) {
      button.addEventListener("click", function () {
        self.selectDate(button.getAttribute("data-date"));
      });
    });

    this.updateWeeklyLabel(this.selectedDate);
    this.updateOverflowChips();
  };

  HomepageEvents.prototype.renderError = function () {
    this.carouselEl.innerHTML =
      '<div class="homepage-events__slide homepage-events__slide--error">' +
      "<p>Couldn't load events right now.</p>" +
      '<a href="/pages/events">View full calendar</a>' +
      "</div>";
  };

  HomepageEvents.prototype.buildCardHtml = function (event) {
    var image = event.banner
      ? '<img class="homepage-events__card-image" loading="lazy" src="' + event.banner + '" alt="">'
      : '<div class="homepage-events__card-image homepage-events__card-image--placeholder" aria-hidden="true">' +
        '<svg viewBox="0 0 448 512" width="32" height="32"><path fill="currentColor" d="M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"/></svg>' +
        "</div>";

    var badge = event.ticketed
      ? '<span class="homepage-events__card-badge homepage-events__card-badge--ticketed" data-handle="' + event.handle + '">Details</span>'
      : '<span class="homepage-events__card-badge">Details</span>';

    return '<a class="homepage-events__card" href="' + buildEventUrl(event) + '">' +
      image +
      '<span class="homepage-events__card-title">' + event.title + "</span>" +
      '<span class="homepage-events__card-time">' + formatEventTime(event.time) + "</span>" +
      badge +
      "</a>";
  };

  HomepageEvents.prototype.buildSlideHtml = function (cell) {
    var self = this;
    var events = this.eventsByDate[cell.date] || [];
    var label = formatDayLabel(cell.date, this.todayISO);
    var body = events.length
      ? '<div class="homepage-events__cards">' + events.map(function (event) { return self.buildCardHtml(event); }).join("") + "</div>"
      : '<p class="homepage-events__empty">No events scheduled</p>';
    return '<div class="homepage-events__slide" data-date="' + cell.date + '">' +
      '<h3 class="homepage-events__slide-label">' + label + "</h3>" +
      body +
      "</div>";
  };

  HomepageEvents.prototype.renderCarousel = function (entryDirection) {
    var self = this;

    if (this.owl) {
      this.owl.trigger("destroy.owl.carousel");
    }

    this.carouselEl.innerHTML = this.gridCells.map(function (cell) { return self.buildSlideHtml(cell); }).join("");

    this.owl = jQuery(this.carouselEl).owlCarousel({
      nav: true,
      navText: [
        '<i class=\'material-icons\' role="button" aria-label="Previous Day"></i>',
        '<i class=\'material-icons\' role="button" aria-label="Next Day"></i>'
      ],
      dots: false,
      items: 1,
      rewind: false,
      loop: false
    });

    var selectedIndex = this.gridCells.findIndex(function (cell) { return cell.date === self.selectedDate; });
    if (selectedIndex > -1) {
      var preJumpIndex = planEntryTurn(entryDirection, selectedIndex, this.gridCells.length);
      this.goToSlide(selectedIndex, preJumpIndex, preJumpIndex !== null ? 300 : 0);
    }

    this.fetchTicketDetails(this.selectedDate);
  };

  HomepageEvents.prototype.updateGridSelection = function (iso) {
    this.selectedDate = iso;
    this.gridEl.querySelectorAll(".homepage-events__day").forEach(function (button) {
      button.classList.toggle("homepage-events__day--selected", button.getAttribute("data-date") === iso);
    });
    this.updateWeeklyLabel(iso);
  };

  HomepageEvents.prototype.updateWeeklyLabel = function (iso) {
    if (this.weeklyLabelEl) this.weeklyLabelEl.textContent = formatWeekdayLabel(iso);
  };

  // Adaptive "+N" overflow chips. All layout READS happen before any WRITE so
  // the ~42 strips share one layout pass; the chip is an absolutely-positioned
  // overlay, so toggling it can never change strip dimensions — measurements
  // cannot feed back into the next measurement.
  HomepageEvents.prototype.updateOverflowChips = function () {
    var measured = [];
    this.gridEl.querySelectorAll(".homepage-events__day-thumbs").forEach(function (strip) {
      var icons = strip.querySelectorAll(".homepage-events__day-thumb");
      var hidden = 0;
      if (icons.length) {
        var firstTop = icons[0].offsetTop;
        icons.forEach(function (icon) {
          if (icon.offsetTop > firstTop) hidden++;
        });
      }
      measured.push({ strip: strip, hidden: hidden });
    });
    measured.forEach(function (entry) {
      entry.strip.classList.toggle("homepage-events__day-thumbs--overflowing", entry.hidden > 0);
      var chip = entry.strip.querySelector(".homepage-events__day-more");
      if (chip) chip.textContent = entry.hidden > 0 ? "+" + entry.hidden : "";
    });
  };

  // Move the carousel with at most one visible slide-width of animation.
  // The 0ms pre-position and the animated move MUST be separated by a forced
  // reflow: both write the stage's CSS transform, and two writes in the same
  // JS tick are batched by the browser into a single computed style — the
  // transition would then run from the ORIGINAL position across the full
  // distance, which is exactly the jarring scroll this exists to prevent.
  HomepageEvents.prototype.goToSlide = function (targetIndex, preJumpIndex, animateMs) {
    if (!this.owl || targetIndex < 0) return;
    if (preJumpIndex !== null) {
      this._suppressIndex = preJumpIndex;
      this.owl.trigger("to.owl.carousel", [preJumpIndex, 0]);
      void this.carouselEl.offsetWidth;
    }
    this.owl.trigger("to.owl.carousel", [targetIndex, animateMs]);
  };

  HomepageEvents.prototype.selectDate = function (iso) {
    var parsed = parseISODate(iso);
    var year = parsed.year;
    var month = parsed.month;

    if (year !== this.currentYear || month !== this.currentMonth) {
      var entryDirection = iso > this.selectedDate ? 1 : -1;
      this.selectedDate = iso;
      this.loadMonth(year, month, entryDirection);
      return;
    }

    var self = this;
    var fromIndex = this.gridCells.findIndex(function (cell) { return cell.date === self.selectedDate; });
    this.updateGridSelection(iso);
    var index = this.gridCells.findIndex(function (cell) { return cell.date === iso; });
    if (index > -1 && this.owl) {
      var plan = planCarouselJump(fromIndex, index);
      this.goToSlide(index, plan.preJumpIndex, plan.animateMs);
    }
    this.fetchTicketDetails(iso);
  };

  HomepageEvents.prototype.onCarouselTranslated = function (index) {
    var self = this;
    var suppressed = this._suppressIndex;
    this._suppressIndex = null;
    if (suppressed !== null && index === suppressed) return;
    var cell = this.gridCells[index];
    if (!cell) return;

    this.updateGridSelection(cell.date);
    this.fetchTicketDetails(cell.date);

    if (!cell.inMonth) {
      var parsed = parseISODate(cell.date);
      var year = parsed.year;
      var month = parsed.month;
      // Defer to the next tick: renderCarousel() destroys and recreates the
      // Owl instance that's currently mid-callback for this very event.
      setTimeout(function () {
        self.selectedDate = cell.date;
        self.loadMonth(year, month);
      }, 0);
    }
  };

  HomepageEvents.prototype.fetchTicketDetails = function (iso) {
    var self = this;
    var events = this.eventsByDate[iso] || [];
    events
      .filter(function (event) {
        return event.ticketed && event.handle && !self.productCache[event.handle];
      })
      .forEach(function (event) {
        fetch("/products/" + event.handle + ".js")
          .then(function (response) {
            if (!response.ok) throw new Error("Product fetch failed: " + response.status);
            return response.json();
          })
          .then(function (product) {
            self.productCache[event.handle] = product;
            self.updateCardBadge(event.handle, product);
          })
          .catch(function () {
            self.updateCardBadge(event.handle, null);
          });
      });
  };

  HomepageEvents.prototype.updateCardBadge = function (handle, product) {
    var badge = this.carouselEl.querySelector('.homepage-events__card-badge--ticketed[data-handle="' + handle + '"]');
    if (!badge) return;
    if (!product) {
      badge.textContent = "Details";
      return;
    }
    if (product.available && product.price > 0) {
      badge.textContent = Shopify.formatMoney(product.price, window.theme.moneyWithCurrencyFormat);
    } else if (product.available && product.price === 0) {
      badge.textContent = "Free";
    } else {
      badge.textContent = "Sold out";
    }
  };

  return {
    formatISODate: formatISODate,
    getMonthFetchRange: getMonthFetchRange,
    bucketEventsByDate: bucketEventsByDate,
    buildMonthGrid: buildMonthGrid,
    formatDayLabel: formatDayLabel,
    formatEventTime: formatEventTime,
    buildEventUrl: buildEventUrl,
    parseISODate: parseISODate,
    planCarouselJump: planCarouselJump,
    planEntryTurn: planEntryTurn,
    formatWeekdayLabel: formatWeekdayLabel,
    Widget: HomepageEvents
  };
});
